
<div class="add_company">
  <div class="top_panel">
    <h3>Create a Payment </h3>
    <span (click)="close()" class="close">
      <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  </div>
  <div class="add_body">
    <form [formGroup]="chargeCopayForm">
      <div class="card_detail">
        <h3>Personal Information</h3>
       <div class="flex_prt">
        <div class="card_panel">
          <label>First Name</label>
          <span>
            <input
              type="text"
              placeholder="First Name"
              formControlName="firstName"
              (keyup)="apiService.restrictSpace($event)"
              (keypress)="apiService.restrictSpecialChar($event)"
            />
            <mat-error
              *ngIf="
                chargeCopayForm.controls['firstName'].touched &&
                chargeCopayForm.controls['firstName'].hasError('required')
              "
            >
              This is required
            </mat-error>
            <mat-error
              *ngIf="
                chargeCopayForm.controls['firstName'].touched &&
                chargeCopayForm.controls['firstName'].hasError('minlength')
              "
            >
            Minimum length should be 2.
            </mat-error>
          </span>
        </div>
        <div class="card_panel">
          <label>Last Name</label>
          <span>
            <input
              type="text"
              placeholder="Last Name"
              formControlName="lastName"
              (keyup)="apiService.restrictSpace($event)"
              (keypress)="apiService.restrictSpecialChar($event)"
            />
            <mat-error
              *ngIf="
                chargeCopayForm.controls['lastName'].touched &&
                chargeCopayForm.controls['lastName'].hasError('required')
              "
            >
              This is required
            </mat-error>
            <mat-error
            *ngIf="
              chargeCopayForm.controls['lastName'].touched &&
              chargeCopayForm.controls['lastName'].hasError('minlength')
            "
          >
            Minimum length should be 2.
          </mat-error>
          </span>
        </div>
        <div class="card_panel">
          <label>Phone Number</label>
          <span>
            <input
              type="text"
              placeholder="Phone Number"
              formControlName="phoneNumber"
              mask="(000) 000-0000"
            />
            <mat-error
              *ngIf="
                chargeCopayForm.controls['phoneNumber'].touched &&
                chargeCopayForm.controls['phoneNumber'].hasError('required')
              "
            >
              This is required
            </mat-error>
            <mat-error
              *ngIf="
                chargeCopayForm.controls['phoneNumber'].touched &&
                chargeCopayForm.controls['phoneNumber'].hasError('pattern') &&
                !chargeCopayForm.controls['phoneNumber'].hasError('required')
              "
            >
              Enter valid phone number.
            </mat-error>
            
          </span>
        </div>
        <div class="card_panel">
          <label>Email Address</label>
          <span>
            <input
              type="text"
              placeholder="Email Address"
              formControlName="emailAddress"
            />
            <mat-error
              *ngIf="
                chargeCopayForm.controls['emailAddress'].touched &&
                chargeCopayForm.controls['emailAddress'].hasError('required')
              "
            >
              This is required
            </mat-error>
            <mat-error
            *ngIf="
              chargeCopayForm.controls['emailAddress'].touched &&
              chargeCopayForm.controls['emailAddress'].hasError('pattern')
            "
          >
            Enter valid email address.
          </mat-error>
          </span>
        </div>
       </div>
        
       <h3>Contact</h3>
       <div class="flex_prt">
        <div class="card_panel addres">
          <label> Address </label>
          <span>
              <input
              type="text"
              placeholder="Address"
              formControlName="streetAddress"
              #billingLocation
              />
              <mat-error *ngIf="chargeCopayForm.controls['streetAddress'].touched && chargeCopayForm.controls['streetAddress'].hasError('required')">
                This is required field.
              </mat-error>
          </span>
      </div>
      <div class="card_panel unit">
          <label> Unit Number </label>
          <span>
              <input
              type="text"
              placeholder="Unit Number"
              formControlName="unitNumber"
              />
              <mat-error *ngIf="chargeCopayForm.controls['unitNumber'].touched && chargeCopayForm.controls['unitNumber'].hasError('required')">
                This is required field.
              </mat-error>
          </span>
      </div>
      <div class="cardflex">
        <div class="card_panel">
          <label>City </label>
          <span>
            <input
              type="text"
              placeholder="City"
              formControlName="city"
              readonly
            />
            <mat-error *ngIf="chargeCopayForm.controls['city'].touched && chargeCopayForm.controls['city'].hasError('required')">
              This is required field.
            </mat-error>
          </span>
        </div>
        <div class="card_panel">
          <label>State </label>
          <span>
            <input
              type="text"
              placeholder="State"
              formControlName="state"
              readonly
            />
            <mat-error *ngIf="chargeCopayForm.controls['state'].touched && chargeCopayForm.controls['state'].hasError('required')">
              This is required field.
            </mat-error>
          </span>
        </div>
        <div class="card_panel">
          <label> Zip </label>
          <span>
            <input
              type="text"
              placeholder="Zip"
              formControlName="zip"
              mask="00000" 
              (keyup)="checkZipCode($event)"
            />
            <mat-error *ngIf="chargeCopayForm.controls['zip'].touched && chargeCopayForm.controls['zip'].hasError('required')">
              This is required field.
            </mat-error>
            <mat-error *ngIf="chargeCopayForm.controls['zip'].hasError('notValid')">
              Please enter valid zip.
          </mat-error>
          </span>
        </div>
      </div>
       </div>
       <h3>Payment</h3>
       <div class="flex_prt">
              <div class="card_panel">
                <label> Claim Number </label>
                <span>
                  <input
                    type="text"
                    placeholder="Claim Number"
                    formControlName="claimNumber"
                    (keypress)="claimNumberValidation($event)"
                  />
                  <mat-error
                    *ngIf="
                      chargeCopayForm.controls['claimNumber'].touched &&
                      chargeCopayForm.controls['claimNumber'].hasError('required')
                    "
                  >
                    This is required
                  </mat-error>
                </span>
            </div>
            <div class="card_panel">
                <label> Copay Amount </label>
                <span>
                  <input
                    type="text"
                    placeholder="Copay Amount"
                    formControlName="copayAmount"
                    mask="separator.2" thousandSeparator=","  [prefix]="chargeCopayForm.controls['copayAmount'].value ? '$' : ''"
                  />
                  <mat-error
                    *ngIf="
                      chargeCopayForm.controls['copayAmount'].touched &&
                      chargeCopayForm.controls['copayAmount'].hasError('required')
                    "
                  >
                    This is required
                  </mat-error>
                </span>
              </div>
          <div class="card_panel full">
            <label> Card Number </label>
            <span>
              <input
                type="text"
                placeholder="**** **** **** ****"
                formControlName="cardNumber"
                [hiddenInput]="true"
                [mask]="
                  cardType == 'American Express'
                    ? 'XXXX XXXXXX X0000'
                    : 'XXXX XXXX XXXX 0000'
                "
                (ngModelChange)="detectCardType($event)"
              />
              <span *ngIf="cardType && cardType == 'Visa'" class="cardlogo">
                <img
                  src="https://cdn.elitehw.com/images/visa-card-logo.png"
                  alt="visa"
                />
              </span>
              <span
                *ngIf="cardType && cardType == 'Mastercard'"
                class="cardlogo mastercard"
              >
                <img src="https://cdn.elitehw.com/images/master-card.png" alt="master-card" />
              </span>
              <span
                *ngIf="cardType && cardType == 'American Express'"
                class="cardlogo"
              >
                <img
                  src="https://cdn.elitehw.com/images/American-Express.png"
                  alt="american-express"
                />
              </span>
              <span *ngIf="cardType && cardType == 'Discover'" class="cardlogo">
                <img src="https://cdn.elitehw.com/images/discover.png" alt="discover" />
              </span>
              <mat-error
                *ngIf="
                  chargeCopayForm.controls['cardNumber'].touched &&
                  chargeCopayForm.controls['cardNumber'].hasError('required')
                "
              >
                This is required
              </mat-error>
              <mat-error
                *ngIf="
                  chargeCopayForm.controls['cardNumber'].touched &&
                  chargeCopayForm.controls['cardNumber'].hasError('mask')
                "
              >
                Enter Valid Card Number
              </mat-error>
            </span>
          </div>
          <div class="card_panel">
            <label> Expiration Date </label>
            <span>
              <input
                type="text"
                placeholder="00/00"
                formControlName="monthYear"
                mask="00/00"
              />
              <mat-error
                *ngIf="
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['monthYear'].hasError('required')
                "
              >
                This is required
              </mat-error>
              <mat-error
                *ngIf="
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['monthYear'].hasError('mask') &&
                  !chargeCopayForm.controls['monthYear'].hasError('required')
                "
              >
                Enter valid Expiry month and year.
              </mat-error>
              <mat-error
                *ngIf="
                  !chargeCopayForm.controls['monthYear'].hasError('required') &&
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['expiryMonth'].hasError('max') &&
                  !chargeCopayForm.controls['monthYear'].hasError('mask') &&
                  chargeCopayForm.controls['expiryYear'].valid
                "
              >
                Enter Valid Expire Month.
              </mat-error>
              <mat-error
                *ngIf="
                  !chargeCopayForm.controls['monthYear'].hasError('required') &&
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['expiryMonth'].hasError('min') &&
                  !chargeCopayForm.controls['monthYear'].hasError('mask')
                "
              >
                Expiry Month value should be greater then 1.
              </mat-error>
              <mat-error
                *ngIf="
                  !chargeCopayForm.controls['monthYear'].hasError('required') &&
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['expiryYear'].hasError('min') &&
                  !chargeCopayForm.controls['monthYear'].hasError('mask') &&
                  chargeCopayForm.controls['expiryMonth'].valid
                "
              >
                Enter Valid Expire Year.
              </mat-error>
              <mat-error
                *ngIf="
                  !chargeCopayForm.controls['monthYear'].hasError('required') &&
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['expiryMonth'].hasError('max') &&
                  !chargeCopayForm.controls['monthYear'].hasError('mask') &&
                  !chargeCopayForm.controls['monthYear'].hasError('required') &&
                  chargeCopayForm.controls['monthYear'].touched &&
                  chargeCopayForm.controls['expiryYear'].hasError('min') &&
                  !chargeCopayForm.controls['monthYear'].hasError('mask')
                "
              >
                Enter valid expire month and year.
              </mat-error>
              <mat-error *ngIf="
              !chargeCopayForm.controls['monthYear'].hasError('required') && 
              chargeCopayForm.controls['expiryMonth'].hasError('notValid') && 
              !chargeCopayForm.controls['monthYear'].hasError('mask') &&
              chargeCopayForm.controls['monthYear'].touched &&
              !chargeCopayForm.controls['expiryYear'].hasError('min')">
                Enter Valid Expire Month.
            </mat-error>
            </span>
          </div>
          <div class="card_panel">
            <label>CVV</label>
            <span>
              <input type="text" placeholder="CVV Code" formControlName="cvv"  [hiddenInput]="true" [hiddenInput]="true"  [mask]="cardType == 'American Express' ? 'XXXX' : 'XXX'"/>
            <mat-error *ngIf="chargeCopayForm.controls['cvv'].touched && chargeCopayForm.controls['cvv'].hasError('required')">
              This is required
            </mat-error>
            <mat-error *ngIf="chargeCopayForm.controls['cvv'].touched && chargeCopayForm.controls['cvv'].hasError('mask')">
              Enter valid cvv code.
            </mat-error>
            </span>
          </div>
       </div>
          
      </div>

      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button
        class="sub-button"
        mat-button
        *ngIf="!isLoading"
        (click)="chargeCopay()"
      >
        Charge
      </button>
      <img [src]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
        <button class="can-button" mat-button (click)="close()" *ngIf="!isLoading">Close</button>
      </div>
    </form>
  </div>
</div>